import UserFollowingPlaylists from "./UserFollowingPlaylists";

export default UserFollowingPlaylists;
